import React from 'react';
import { FiLayers, FiBarChart, FiRadio,FiLock } from "react-icons/fi";
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";
import { useTranslation } from "react-i18next";


const BenefitEmployee = ({textAlign, serviceStyle}) => {
    const { t } = useTranslation('enterprise');
    const BenefitList = [
        {
            icon: <FiLayers />,
            title: t('avantages.lesAvantagesSalaries.avantages.titre1'),
            description: t('avantages.lesAvantagesSalaries.avantages.un')
        },
        {
            icon: <FiBarChart />,
            title: t('avantages.lesAvantagesSalaries.avantages.titre2'),
            description: t('avantages.lesAvantagesSalaries.avantages.deux')
        },
        {
            icon: <FiRadio />,
            title: t('avantages.lesAvantagesSalaries.avantages.titre3'),
            description: t('avantages.lesAvantagesSalaries.avantages.trois')
        },
        {
            icon: <FiLock/>,
            title: t('avantages.lesAvantagesSalaries.avantages.titre4'),
            description: t('avantages.lesAvantagesSalaries.avantages.quatre')
        },
    ]
    return (
        <div className="row row--15 service-wrapper">
              {BenefitList.map( (val , i) => (
                <div className="col-lg-3 col-md-6 col-sm-6 col-12" key={i}>
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={`service ${serviceStyle} ${textAlign}`} style={{height:"350px"}}>
                            <div className="icon">
                                {val.icon}
                            </div>
                            <div className="content">
                                <h4 className="title w-600"><Link to="#service" dangerouslySetInnerHTML={{__html: val.title}}></Link></h4>
                                <p className="description b1 color-gray mb--0" dangerouslySetInnerHTML={{__html: val.description}}></p>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default BenefitEmployee;